if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if($('.swiper_thumb').is(':visible')){
              var galleryThumbs = new Swiper('.swiper_thumb', {
                spaceBetween: 30,
                slidesPerView: 4,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                navigation: {
                  nextEl: '.swiper_thumb .swiper-button-next',
                  prevEl: '.swiper_thumb .swiper-button-prev',
                },
              });
              var galleryTop = new Swiper('.swiper_main', {
                spaceBetween: 0,
                navigation: {
                  nextEl: '.swiper_main .swiper-button-next',
                  prevEl: '.swiper_main .swiper-button-prev',
                },
                thumbs: {
                  swiper: galleryThumbs
                }
              });
            }else{
                var galleryTop = new Swiper('.swiper_main', {
                spaceBetween: 0,
                navigation: {
                  nextEl: '.swiper_main .swiper-button-next',
                  prevEl: '.swiper_main .swiper-button-prev',
                }
              });
            }

            var metaThumbs = new Swiper('.meta_img_thumb_main', {
              spaceBetween: 30,
              slidesPerView: 4,
              navigation: {
                nextEl: '.meta_img_thumb_main .swiper-button-next',
                prevEl: '.meta_img_thumb_main .swiper-button-prev',
              },
              breakpoints: {
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                500: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1000: {
                  slidesPerView: 4,
                }
              }
            });

            var input_Color = $("input[name='Acryl Color']:checked").val();
            var input_Style = $("input[name='Style']:checked").val();
            $("input[name='Acryl Color']").closest('.product-form__input').find('.sel_variant').text(input_Color);
            $("input[name='Style']").closest('.product-form__input').find('.sel_variant').text(input_Style);
          
            $('.cstm_input').on('change', function(){
               var input_name = $(this).attr('name');
              var input_Color = $("input[name='" +input_name+ "']:checked").val();
              $(this).closest('.product-form__input').find('.sel_variant').text(input_Color);
            });
          
            // hide multirow
            if($('.multirow .multirow__inner').is(':empty')){
              $('.multirow__inner').closest('.multirow').hide();
            }
            if($('.metafiled_media')[0]){
              $('body').addClass('has_bnr');
            }
                    
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
